import { DialogActions, DialogContent, Grid, Switch, Tooltip } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Warning } from '@mui/icons-material';
import { Modal } from '../../../../ui/components/pure/modal/modal.component';
import { TextButton } from '../../../../ui/components/pure/text-button/text-button.component';
import {
  EditDeliveryContainerProjectModulesProps,
  ProjectModuleAssignedToDeliveryContainer,
  useEditDeliveryContainerProjectModulesAction
} from '../hooks/edit-project-modules-action.hook';

const useStyles = makeStyles(() => ({
  tooltip: {
    fontSize: '12px'
  },
  warningIconPlaceholder: {
    width: '2.1875em', // To match the size of the Warning icon
    display: 'inline-block'
  },
  capabilitiesTitle: {
    textTransform: 'uppercase'
  },
  dialogContent: {
    marginBottom: '16px'
  },
  noCapabilitiesMessage: {
    color: '#6B7280',
    fontSize: '14px',
    marginTop: '16px'
  }
}));

export function EditProjectModulesActionComponent(props: EditDeliveryContainerProjectModulesProps) {
  const { form, handlers, isLoading, modulesForSelection, state } = useEditDeliveryContainerProjectModulesAction(props);

  const classes = useStyles();

  let modalTitle = 'Edit Project Modules';

  return (
    <Modal open title={modalTitle} loading={isLoading || state.loading} maxWidth="md">
      <form noValidate autoComplete="off" onSubmit={form.handleSubmit(handlers.onSubmit)}>
        <DialogContent className={classes.dialogContent}>
          <Grid container direction="row" spacing={6}>
            <Grid>
              <p className={classes.capabilitiesTitle}>Selected for these Modules</p>
              {!modulesForSelection.length ? <NoProjectModules /> : null}
              <Grid container spacing={2} sx={{ flexDirection: 'column' }}>
                {modulesForSelection.map((module) => (
                  <ProjectModuleRow
                    key={module.label}
                    module={module}
                    onChange={(name, value) => handlers.onChange(name, module.type, value)}
                  />
                ))}
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions style={{ borderTop: '1px solid #EBEDF2', padding: '16px 24px' }}>
          <TextButton color="secondary" variant="outlined" onClick={handlers.onCancel}>
            Cancel
          </TextButton>
          <TextButton color="primary" variant="outlined" type="submit">
            Save
          </TextButton>
        </DialogActions>
      </form>
    </Modal>
  );
}

function ProjectModuleRow(props: {
  module: ProjectModuleAssignedToDeliveryContainer;
  onChange: (module: string, value: boolean) => void;
  disabled?: boolean;
}) {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    props.onChange(props.module.value, event.target.checked);
  };

  const classes = useStyles();

  const tooltipLabel = props.module.warning;

  const Icon = props.module.Icon ?? (() => null);

  return (
    <Grid
      container
      direction="row"
      spacing={2}
      sx={{
        alignItems: 'center'
      }}
    >
      <Grid>
        <Icon></Icon>
      </Grid>
      <Grid size="grow">
        <p>{props.module.label}</p>
      </Grid>
      <Switch disabled={props.disabled} checked={props.module.isSelected} onChange={handleChange} />
      <Grid>
        {!tooltipLabel ? (
          <span className={classes.warningIconPlaceholder}>&nbsp; {/* Placeholder for alignment */}</span>
        ) : (
          <Tooltip
            classes={{
              tooltip: classes.tooltip
            }}
            title={tooltipLabel}
            placement="top"
          >
            <Warning fontSize="large" color="error" />
          </Tooltip>
        )}
      </Grid>
    </Grid>
  );
}

function NoProjectModules() {
  const classes = useStyles();
  return <span className={classes.noCapabilitiesMessage}>None available</span>;
}
